import { Injectable } from '@angular/core';
import { Student } from '../../models/student';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WardsService {

  private _wards: ReplaySubject<Array<Student>> = new ReplaySubject<Array<Student>>(1);
  public wards$ = this._wards.asObservable();

  private _ward: ReplaySubject<Student> = new ReplaySubject<Student>(1);
  public ward$ = this._ward.asObservable();

  constructor() { }

  setWard(ward: Student) {
    this._ward.next(ward);
  }

  setWards(wards: Array<Student>) {
    this._wards.next(wards);
  }
}
